import React, { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"

const initialValue = {id: null, FirstName: "", LastName: "", Email: "", MobileNumber: "", SystemAdmin: false}

const AddEditUserModal = ({editUser = null, show, onHide, onSave, onDelete}) => {
    const [user, setUser] = useState(initialValue)
    
    useEffect(()=>{

        if(editUser) {
            setUser({
                id: editUser.id,
                FirstName: editUser.FirstName || "",
                LastName: editUser.LastName || "",
                Email: editUser.Email || "",
                MobileNumber: editUser.MobileNumber || "",
                SystemAdmin: editUser.SystemAdmin === "true"
            })
        } else {
            setUser(initialValue)
        }
    }, [show])

    const handleSave = () => {
        onSave(user)
    }

    const handleDelete = () => {
        onDelete(user)
    }

    const handleChange = (e) => {
        setUser({
            ...user,
            [e.target.name]: e.target.value
        })
    }

    const handleCheckboxChange = (e) => {
        setUser({
            ...user,
            [e.target.name]: e.target.checked
        })
    }

    return <Modal show={show} onHide={onHide}>
        <Modal.Header>
            <Modal.Title>
                {editUser ? "Edit user #"+editUser.id : "Create user"}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
            <Form.Group>
                <Form.Label>FirstName</Form.Label>
                <Form.Control type="text" placeholder="Enter first name" name="FirstName" value={user.FirstName} onChange={handleChange} />
            </Form.Group>
            <Form.Group>
                <Form.Label>LastName</Form.Label>
                <Form.Control type="text" placeholder="Enter last name" name="LastName" value={user.LastName} onChange={handleChange} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="Email" placeholder="Enter email" value={user.Email} onChange={handleChange}/>
            </Form.Group>
            <Form.Group>
                <Form.Label>Mobile number</Form.Label>
                <Form.Control type="tel" name="MobileNumber" placeholder="Enter mobile number" value={user.MobileNumber} onChange={handleChange}/>
            </Form.Group>
            <Form.Group>
                <Form.Check id="SystemAdminCheckbox" type="checkbox" label="System admin" name="SystemAdmin" checked={user.SystemAdmin} onChange={handleCheckboxChange} />
            </Form.Group>
        </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="default" onClick={onHide}>Cancel</Button>
            {editUser && <Button variant="danger" onClick={handleDelete}>Delete</Button>}
            <Button onClick={handleSave}>Save</Button>
        </Modal.Footer>
    </Modal>
}

export default AddEditUserModal
